'use strict';

const scrollAnimate = require('base/components/scrollAnimate');
const siteAlert = require('./alert');

/**
 * Shows the email signup AJAX result in the site alert.
 * @param {Object} data - data returned from the server's ajax call
 * @param {jQuery} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    button.removeAttr('disabled');

    if (!data.msg) return;

    siteAlert.show({
        type: data.success ? 'success' : 'error',
        message: data.msg,
        timeout: 3000
    });
}

module.exports = function () {
    $('.back-to-top').click(scrollAnimate);

    $('.subscribe-email').on('click', function (e) {
        e.preventDefault();

        const url = $(this).data('href');
        const button = $(this);
        const emailId = $('input[name=hpEmailSignUp]').val();

        $.spinner().start();
        $(this).attr('disabled', true);

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                emailId: emailId
            },
            success: function (data) {
                displayMessage(data, button);
            },
            error: function (err) {
                displayMessage(err, button);
            }
        });
    });
};
